// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3tuPE","center":"_1qiRP","svg":"SGSri","rotate":"_16oHj","dash":"_2AGYD"};


//////////////////
// WEBPACK FOOTER
// ../source/components/Spinner/styles.css
// module id = 1154
// module chunks = 26